<template>
    <div id="myschedule">
        <!-- <van-nav-bar :title="title" fixed placeholder left-text="返回" left-arrow>
            <a @click="$router.back()" slot="left">
                <i class="iconfont iconfanhuianniu"></i>
            </a>
        </van-nav-bar> -->
        <!-- <div class="search">
            <div class="searchbar">
                <i class="iconfont iconSearch left"></i>
                <input v-model="value" type="search" maxlength="11" />
                <i v-if="value" @click="value = ''" class="iconfont iconclose right"></i>
            </div>
        </div> -->
        <div class="fixedH">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false" @load="getList" offset="100">
                <div class="body">
                    <div class="card" v-for="(item,index) in list" :key="index" @click="goTo(item)">
                        <p>
                            <span>{{agentTypeList[item.type-1]}}<span v-if="item.name">-</span>{{item.name}}</span>
                            <span>{{orderStatusList[item.orderStatus-1]}}</span>
                        </p>
                        <p><span>公司名称：{{item.companyName}}</span></p>
                        <p>
                            
                            <span v-if="$route.query.type == 2">当前处理人：{{item.actorName}}</span>
                            <span v-else-if="$route.query.type == 3">处理人：{{item.processActor}}</span>
                        </p>
                        <p>
                            <span>
                                业务编号：{{item.businessNumber}}
                            </span>
                            <span>发起时间：{{item.actorTime}}</span>
                        </p>
                        <p>
                            <!-- <span></span> -->
                            <span v-if="item.type==9">
                                合约结束日期：{{item.orderDate}}
                            </span>
                        </p>
                        <p>
                            <!-- <span></span> -->
                            <span v-if="item.address">
                                地址：{{item.address}}
                            </span>
                        </p>
                        <p>
                            <!-- <span class="go" v-if="item.type == 5" @click="receipt(item)">接单</span>
              <span
                class="go"
                v-else-if="$route.query.type == '2' && item.processStatus == 2"
                @click="goTo(item)"
              >审批</span>-->
                        </p>
                    </div>
                </div>
            </van-list>
            <div style="height:1.2rem;"></div>
            <div class="btn">
                <van-button class="font1" type="primary" block @click="showSearch = !showSearch">筛选</van-button>
            </div>
        </div>
        <transition name="van-fade">
            <div v-show="showSearch" class="filter">
                <div class="field field1">
                    <div class="searchT">待办类型</div>
                    <div class="flex">
                        <div :class="{'active':listQuery.agentType == null}" @click="listQuery.agentType = null">全部</div>
                        <div v-for="(item,index) in agentTypeList" :key="index" :class="{'active':listQuery.agentType == index+1}" @click="listQuery.agentType = index+1">{{item}}</div>
                    </div>
                </div>
                <div class="field field1">
                    <div class="searchT">流程状态</div>
                    <div class="flex">
                        <div :class="{'active':listQuery.status == null}" @click="listQuery.status = null">全部</div>
                        <div v-for="(item,index) in orderStatusList" v-show="index !== 3" :key="index" :class="{'active':listQuery.status == index+1}" @click="listQuery.status = index+1">{{item}}</div>
                    </div>
                </div>
                <div class="field field1" v-if="this.$route.query.type == 2">
                    <div class="searchT">数据</div>
                    <div class="flex">
                        <div :class="{'active':listQuery.authActorType == null}" @click="listQuery.authActorType = null;listQuery.authActorId = []">全部</div>
                        <div :class="{'active':listQuery.authActorType == 1}" @click="listQuery.authActorType = 1;listQuery.authActorId = [user.accountId]">我自己的</div>
                        <div :class="{'active':listQuery.authActorType == 2}" @click="listQuery.authActorType = 2;listQuery.authActorId = []">下属的</div>
                    </div>
                    <div class="select" v-if="listQuery.authActorType == 2">
                        <select v-model="listQuery.authActorId" multiple="multiple">
                            <option v-for="(item,index) in chargeTypeList" :key="index" :value="item.id">{{item.name}}</option>
                        </select>
                    </div>
                </div>
                <div style="height:1.2rem;"></div>
                <div class="bottom">
                    <van-button class="font5" type="default" @click="resetSearch">重置</van-button>
                    <van-button class="font5" type="primary" @click="searchConfirm">确定</van-button>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { mapState } from "vuex";
import * as dd from "dingtalk-jsapi"; //钉钉
import {
    requestWorkflowCurrent,
    requestWorkflowWait,
    requestWorkflowInvolved,
    requestReceiveTransfer,
    requestAgentType,
    requestChargeList,
} from "@/api";
import { accSub } from "@/utils";
export default {
    name: "myschedule",
    data() {
        return {
            title: "",
            list: [],
            loading: false,
            finished: false,
            showSearch: false,
            titleArr: ["", "我发起的", "我的待办", "我参与的"],
            agentTypeList: [
                "审批代办",
                "账单代办",
                "房源代办",
                "预约代办",
                "渠道派单",
                "换房申请",
                "转租申请",
                "续约申请",
                "退租申请",
                "换房退租申请",
                "工单派单",
            ],
            taskTypeList: ["审批", "抄送"],
            readStatusList: ["已读", "未读"],
            processStatusList: ["已处理", "未处理", "作废"],
            orderStatusList: ["审批中", "同意", "驳回", "", "结束"], //流程状态1：审批中，2：同意， 3：驳回  5：结束
            value: "",
            listQuery: {
                pageNumber: 1,
                pageSize: 10,
                number: null, // 代办编码
                agentType: null, //代办类型
                status: null, //流程状态
                authActorId: [],
                authActorType: null,
                chargeTypeList: [], //当前处理人
            },
        };
    },
    computed: {
        ...mapState([
            "idTypeList",
            "destineList",
            "payList",
            "contractList",
            "user",
        ]),
    },
    created() {
        // if (dd.env.platform !== "notInDingTalk") {
        //     dd.ready(function() {
        //         dd.biz.navigation.setTitle({
        //             title: this.titleArr[this.$route.query.type / 1] || "CRM",
        //             onSuccess: function(result) {},
        //             onFail: function(err) {}
        //         });
        //     });
        // }
        // document.title = this.titleArr[this.$route.query.type / 1] || "CRM";
    },
    mounted() {
        // this.listQuery.pageNumber = 1;
        // this.getList();
        // this.getChargeType(this.user.accountId);
    },
    activated() {
        if (dd.env.platform !== "notInDingTalk") {
            dd.ready(function () {
                dd.biz.navigation.setTitle({
                    title: this.titleArr[this.$route.query.type / 1] || "CRM",
                    onSuccess: function (result) {},
                    onFail: function (err) {},
                });
            });
        }
        document.title = this.titleArr[this.$route.query.type / 1] || "CRM";
        this.listQuery.pageNumber = 1;
        this.finished = false;
        this.list = [];
        this.getList();
        this.getChargeType(this.user.accountId);
    },
    methods: {
        //代办类型
        // getAgentType() {
        //     requestAgentType().then(res => {
        //         this.agentTypeList = res.data;
        //     });
        // },
        //当前处理人
        getChargeType(accountId) {
            requestChargeList(accountId).then((res) => {
                this.chargeTypeList = res.data;
            }).catch(err=>{
                
            });
        },
        //发起
        getCurrent() {
            requestWorkflowCurrent(this.listQuery)
                .then((res) => {
                    if (this.finished) return;
                    this.list = [...this.list, ...res.data.records];
                    let prePage = accSub(res.data.pages, 1);
                    this.loading = false;
                    this.listQuery.pageNumber++;
                    if (
                        (res.data.pages == res.data.current &&
                            res.data.records.length ==
                                accSub(res.data.total, prePage * 10)) ||
                        !res.data.records.length
                    ) {
                        this.finished = true;
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.finished = true;
                });
        },
        //待办
        getWaiting() {
            requestWorkflowWait(this.listQuery)
                .then((res) => {
                    if (this.finished) return;
                    this.list = [...this.list, ...res.data.records];
                    let prePage = accSub(res.data.pages, 1);
                    this.loading = false;
                    if(this.listQuery.pageNumber<res.data.pages)this.listQuery.pageNumber++;
                    
                    console.log(this.listQuery.pageNumber)
                    if (
                        (res.data.pages == res.data.current &&
                            res.data.records.length ==
                                accSub(res.data.total, prePage * 10)) ||
                        !res.data.records.length
                    ) {
                        this.finished = true;
                    }
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
        //参与
        getInvolved() {
            requestWorkflowInvolved(this.listQuery)
                .then((res) => {
                    if (this.finished) return;
                    this.list = [...this.list, ...res.data.records];
                    let prePage = accSub(res.data.pages, 1);
                    this.loading = false;
                    this.listQuery.pageNumber++;
                    if (
                        (res.data.pages == res.data.current &&
                            res.data.records.length ==
                                accSub(res.data.total, prePage * 10)) ||
                        !res.data.records.length
                    ) {
                        this.finished = true;
                    }
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
        getList() {
            switch (this.$route.query.type / 1) {
                case 1:
                    this.getCurrent();
                    break;
                case 2:
                    this.getWaiting();
                    break;
                case 3:
                    this.getInvolved();
                    break;

                default:
                    break;
            }
        },
        resetSearch() {
            this.listQuery = {
                pageNumber: 1,
                pageSize: 10,
                number: null, // 代办编码
                agentType: null, //代办类型
                status: null, //流程状态
                authActorId: [],
                authActorType: null,
                chargeTypeList: [], //当前处理人
            };
            this.list = [];
            this.finished = false;
            this.showSearch = false;
            this.getList();
        },
        searchConfirm() {
            this.listQuery.pageNumber = 1;
            this.finished = false;
            this.showSearch = false;
            this.list = [];
            this.getList();
        },
        //接单
        // receipt(item) {
        //   this.$dialog.confirm({
        //     message: "确认接单？",
        //     confirmButtonText: "确定",
        //     cancelButtonText: "取消",
        //     beforeClose: (action, done) => {
        //       if (action === "confirm") {
        //         requestReceiveTransfer(item.id)
        //           .then(res => {
        //             this.$toast.success("接单成功");
        //             this.listQuery.pageNumber = 1;
        //             this.list = [];
        //             this.getList();
        //             done();
        //           })
        //           .catch(err => {
        //             done(false);
        //           });
        //       } else {
        //         done();
        //       }
        //     }
        //   });
        // },
        //审批
        goTo(row) {
            console.log(row);
            if (row.actorId !== this.user.accountId) {
                this.$toast.fail("您无权处理此待办");
                return;
            }
            if (row.companyId !== this.user.companyId) {
                this.$toast.fail("请先切换至此待办所属公司");
                return;
            }
            if (row.type == 5) {
                //派单
                this.$router.push({
                    path: "customerDetail",
                    query: { id: row.businessId, agentId: row.id },
                });
            } else if (row.type > 5 && row.type < 11) {
                //申请
                this.$router.push({
                    path: "applyDetail",
                    query: {
                        id: row.businessId,
                        agentId: row.id,
                        agentType: row.type,
                        type: this.$route.query.type / 1,
                    },
                });
            } else if (row.type == 11) {
                //工单派单
                this.$router.push({
                    path: "workOrderDetail",
                    query: {
                        id: row.businessId,
                        agentId: row.id,
                        agentType: row.type,
                        type: this.$route.query.type / 1,
                    },
                });
            } else if (
                this.$route.query.type == "2" &&
                row.processStatus == 2
            ) {
                //审批
                let param = {
                    id: row.businessId,
                    agentId: row.id,
                    orderId: row.orderId,
                    type: 1,
                };
                switch (row.businessType) {
                    case 1:
                        //分散式收房合约
                        this.$router.push({
                            path: "fssContractDetail",
                            query: param,
                        });
                        break;
                    case 2:
                        //分散式租房合约
                        this.$router.push({
                            path: "contractDetail",
                            query: param,
                        });
                        break;
                    case 3:
                        //分散式收房退租
                        this.$router.push({
                            path: "fssReturnDetail",
                            query: param,
                        });
                        break;
                    case 4:
                        //分散式租房退租
                        this.$router.push({
                            path: "returnOrderDetail",
                            query: param,
                        });
                        break;
                    case 5:
                        //租房预定
                        this.$router.push({
                            path: "destineDetail",
                            query: param,
                        });
                        break;
                    case 6:
                        //集中式收房合约
                        this.$router.push({
                            path: "jzsContractDetail",
                            query: param,
                        });
                        break;
                    case 7:
                        //集中式租房合约
                        this.$router.push({
                            path: "contractDetail",
                            query: param,
                        });
                        break;
                    case 8:
                        //集中式收房退租
                        this.$router.push({
                            path: "jzsReturnDetail",
                            query: param,
                        });
                        break;
                    case 9:
                        //集中式租房退租
                        this.$router.push({
                            path: "returnOrderDetail",
                            query: param,
                        });
                        break;
                    case 10:
                        //分散式小区
                        this.$router.push({
                            path: "communityDetail",
                            query: param,
                        });
                        break;
                    case 11:
                        //装修单
                        this.$router.push({
                            path: "remodelDetail",
                            query: param,
                        });
                        break;
                     case 19:
                        //装修单
                        this.$router.push({
                            path: "jointOrderADetail",
                            query: param,
                        });
                        break;    
                    default:
                        break;
                }
                // debugger
            }
        },
    },
    watch: {},
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
#myschedule {
    .fixedH {
        height: 100vh;
        overflow: scroll;
    }
    .body {
        // padding-top: 0.001rem;
        font-size: 0.35rem;
        .card {
            background: #fff;
            // margin: 0.5rem 0.3rem;
            // border-radius: 0.2rem;
            margin: 0.2rem 0;
            p {
                display: flex;
                justify-content: space-between;
                padding: 0 0.4rem;
                line-height: 0.8rem;
                .go {
                    color: $theme-color;
                }
            }
        }
        > .card:first-child {
            margin-top: 0;
        }
    }
    .search {
        padding: 0.3rem;
        .searchbar {
            padding: 0.3rem;
            background-color: #fff;
            border-radius: 0.3rem;
            position: relative;
            .left {
                position: absolute;
                left: 0.3rem;
            }
            .right {
                position: absolute;
                right: 0.3rem;
            }
            input {
                background: none;
                outline: none;
                border: none;
                width: calc(100% - 1.5rem);
                text-align: center;
                height: 0.5rem;
                line-height: 0.5rem;
            }
        }
    }
    .filter {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        background-color: #fff;
        z-index: 99;
        overflow: scroll;
        // padding-top: 0.4rem;
        .field {
            padding: 0 0.7rem;
            .searchT {
                text-align: left;
                font-size: 0.41rem;
                font-weight: 600;
                color: #666666;
                margin: 0.4rem 0;
                // padding-left: 0.4rem;
            }
            /deep/.van-cell {
                border: 1px solid $border-color;
            }
            .flex {
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;
                padding-left: 0.35rem;
                > div {
                    margin: 0.2rem 0.35rem;
                    width: 2.4rem;
                    height: 0.8rem;
                    line-height: 0.8rem;
                    border: 1px solid $border-color;
                    &.active {
                        border: 1px solid $theme-color;
                        color: $theme-color;
                    }
                }
            }
            .select {
                width: auto;
                height: 0.8rem;
                line-height: 0.8rem;
                border: 1px solid $border-color;
                margin: 0.2rem 0.7rem;
                select {
                    width: 100%;
                    height: 100%;
                    padding: 0 0.2rem;
                    color: #666666;
                }
            }
        }
        .field1 {
            padding: 0;
            .searchT {
                padding: 0 0.7rem;
            }
            select {
                /*将默认的select选择框样式清除*/
                appearance: none;
                -moz-appearance: none;
                -webkit-appearance: none;
                border: none;
                background-color: #fff;
            }
            /*IE浏览器隐藏下拉箭头*/
            select::-ms-expand {
                display: none;
            }
        }
        .bottom {
            position: fixed;
            bottom: 0;
            display: flex;
            width: 100%;
            /deep/.van-button--primary {
                margin-left: -1px;
                border: none;
                border-radius: 0;
            }
            .font5 {
                width: 51%;
            }
        }
    }
    .btn {
        width: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        border-radius: 0.1rem;
        overflow: hidden;
        display: flex;
        /deep/.van-button {
            margin-left: -1px;
            border: none;
            border-radius: 0;
            flex: 1;
            padding: 0%;
            &:not(:last-child)::after {
                height: 50%;
                position: absolute;
                box-sizing: border-box;
                content: " ";
                pointer-events: none;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
                border-right: 0.02667rem solid #ebedf0;
                z-index: 99;
            }
        }
    }
}
</style>
